<template>
  <div class="investors-page">
    <DefaultHeader title="Для инвесторов" :back="false" />
    <div class="investors-content">
      <div class="investors-hero">
        <img src="../assets/investors-placeholder.png" alt="Инвесторы" class="hero-image" />
          <div class="investor-buttons-wrapper">
            <div class="investor-buttons">
              <button class="investor-btn primary" @click="sendEmail">📎 Запросить презентацию</button>
              <button class="investor-btn secondary" @click="sendEmail">  📬 Связаться с нами </button>
            </div>
            <div class="founder-text-block">
              <div class="founder-name">Evgeny Tishkin</div>
              <div class="founder-role">CEO, CTO, Founder</div>
            </div>
          </div>
      </div>
    </div>
    <div class="sticky-footer">
      <MiniFooter />
    </div>
  </div>
</template>

<script setup>
import DefaultHeader from '../components/DefaultHeader.vue';
import MiniFooter from '../components/MiniFooter.vue';

function sendEmail() {
  window.location.href = "mailto:ceo@hr3.space";
  setTimeout(() => {
    alert("Если почта не открылась — напишите нам вручную на ceo@hr3.space 📩");
  }, 3000);
}

</script>

<style scoped>
.investors-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--bg-main);
}

.investors-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 24px;
}

.investors-hero {
  max-width: 900px;
  position: relative;
  margin-top: -100px;
}

.hero-image {
  width: 900px;
  height: 900px;
  object-fit: cover;
  border-radius: 24px;
}

.investor-buttons {
  position: absolute;
  bottom: 100px; 
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  z-index: 2;
  width: 600px;
  margin-left: -100px;
}

.investor-btn {
  padding: 14px 28px;
  font-size: 16px;
  font-family: "Eastman-Medium", sans-serif;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.investor-btn.primary {
  background-color: #2277E6;
  color: white;
}

.investor-btn.primary:hover {
  opacity: 0.9;
}

.investor-btn.secondary {
  background-color: transparent;
  border: 2px solid #2277E6;
  color: #2277E6;
}

.investor-btn.secondary:hover {
  background-color: #f0f7ff;
}

.investor-buttons-wrapper {
  position: absolute;
  bottom: 140px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 40px;
  align-items: center;
  z-index: 2;
  flex-wrap: wrap;
  align-items: center; 
}

.founder-text-block {
  margin-left: 724px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
}

.founder-name {
  font-family: "Eastman-Bold", sans-serif;
  font-size: 18px;
  margin-left: 30px;
  color: var(--text-primary);
}

.founder-role {
  font-family: "Eastman-Regular", sans-serif;
  font-size: 14px;
  color: var(--text-secondary);
  margin-top: 4px;
  margin-left: 36px;
}

.sticky-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--bg-main);
  z-index: 999;
}

</style>